<template>
  <div class="grid grid-cols-5 mt-3">
    <div class="col-start-3 col-span-5">
      <ChatGPTActionPlaceholder
        :focus="focus"
        :error="isErrorBubbleFocused && actionId === error.actionId"
        @click="selectChatGPTBubble"
      />
    </div>
  </div>
</template>

<script>
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import previewModule from '@/store/modules/preview.module'
import ChatGPTActionPlaceholder from '@/components/common/ChatGPTActionPlaceholder.vue'

export default {
  name: 'ChatGPTBubble',
  components: { ChatGPTActionPlaceholder },

  props: {
    stateId: { type: String, required: true },
    actionId: { type: String, required: true },
    isTemplate: { type: Boolean, required: true },
    focus: { type: Boolean, required: true },
    inNestedCondition: { type: Boolean, default: false }
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    error: previewModule.error,

    isErrorBubbleFocused() {
      return chatBubbleModule.isErrorBubbleFocused()
    }
  },

  methods: {
    selectChatGPTBubble() {
      chatBubbleModule.selectChatGPTBubble(this.stateId, this.actionId, this.isTemplate, this.inNestedCondition)
    }
  }
}
</script>
